// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fields[data-v-66e6e156] {\n  margin-top: 16px;\n  margin-left: 16px;\n}\n.nested-level-1[data-v-66e6e156] {\n  margin-left: 32px;\n}\n.nested-level-2[data-v-66e6e156] {\n  margin-left: 64px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
